import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref, computed } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'
import store from '@/store'
import endpoints from '@/libs/endpoints'

export default function useBehaviourEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem, getPresignedDownloadUrl } = useLambda()
  const { uploadFileToS3 } = useCommonTodo()
  const userData = store.state?.userStore?.userData
  const behaviour = ref({})
  const isSubmitting = ref(false)
  const isReadOnly = computed(() => route.value.query.view === 'true')
  const query = { _id: oid(route.value.params.id) }
  const collection = 'behaviour'

  const saveImgAWS = (imgFile) => {
    const destinationFolder = `${userData.client.$oid}/behaviours`
    return new Promise((resolve, reject) => {
      uploadFileToS3(imgFile, destinationFolder)
        .then((key) => resolve(key))
        .catch((err) => reject(err))
    })
  }

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      if (item.imageKey) {
        try {
          const { url } = await getPresignedDownloadUrl({ key: item.imageKey })
          const response = await fetch(url)
          if (response.ok) {
            item.imgSrc = await response.text()
          }
        } catch (err) {
          console.log(err)
        }
      }

      behaviour.value = item
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async (data, imgFile, deleteImage) => {
    isSubmitting.value = true

    try {
      const setFields = {
        name: data.name?.value || '',
        value_id: data.value_id?.value ? oid(data.value_id.value) : null,
        description: data.description?.value || '',
      }

      if (imgFile) {
        setFields.imageKey = await saveImgAWS(imgFile)
      } else if (deleteImage) {
        setFields.imageKey = null
      }

      const action = { $set: setFields }

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.behaviour_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.behaviour_update_error'))
    } finally {
      router.push({ name: 'organization-behaviour-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    behaviour,
    isSubmitting,
    isReadOnly,
  }
}
